var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9004 8.72656C17.9004 9.10239 17.7563 9.46569 17.4868 9.72877C17.2236 9.99812 16.8602 10.1484 16.4842 10.1484H10.8197V15.8109C10.8197 16.1868 10.6693 16.5501 10.3998 16.8132C10.1367 17.0762 9.77949 17.2266 9.40352 17.2266C9.02756 17.2266 8.66412 17.0762 8.40094 16.8132C8.1315 16.5501 7.98111 16.1868 7.98111 15.8109V10.1484H2.31654C1.94057 10.1484 1.57713 9.99812 1.31395 9.72877C1.05078 9.46569 0.900391 9.10239 0.900391 8.72656C0.900391 8.35073 1.05078 7.9937 1.31395 7.72435C1.57713 7.46127 1.94057 7.31094 2.31654 7.31094H7.98111V1.64845C7.98111 1.27262 8.1315 0.909319 8.40094 0.646238C8.66412 0.376894 9.02756 0.226562 9.40352 0.226562C9.77949 0.226562 10.1367 0.376894 10.3998 0.646238C10.6693 0.909319 10.8197 1.27262 10.8197 1.64845V7.31094H16.4842C16.8602 7.31094 17.2236 7.46127 17.4868 7.72435C17.7563 7.9937 17.9004 8.35073 17.9004 8.72656Z",
    fill: "#31C2F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMas);
export default __webpack_public_path__ + "static/media/mas.376be2a6694efb7bf8b764eb59da4e6a.svg";
export { ForwardRef as ReactComponent };